module.exports = __webpack_public_path__ + "img/scammer_3.8346d4d1.png";